import { connect } from 'react-redux';
import OrgsList from "./OrgsList";
import {
    fetchGetValidatedOrgs, getCountryFilter, getValidatedOrgsData, loadingOrgs, setCountryFilter
} from '../../../reducers/organization/organizations';
import {getTranslation} from "../../../reducers/common/localization";
import {showModal, MODAL_RESENT_ACTIVATION_ANCHOR, MODAL_REMOVE_ORG} from '../../../reducers/common/activeModal';
import {getSubRoles} from "../../../reducers/account/role";
import {
    getContinentsData,
    getCountriesData,
    getCurrentContinent,
    setCurrentContinent
} from "../../../reducers/common/location";

const mapStateToProps = state => {
    return {
        loading: loadingOrgs(state),
        data: getValidatedOrgsData(state),
        translation: getTranslation(state),
        subRoles: getSubRoles(state),
        continents: getContinentsData(state),
        continentCode: getCurrentContinent(state),
        countries: getCountriesData(state),
        countryFilter: getCountryFilter(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => {
            dispatch(fetchGetValidatedOrgs());
        },
        onResendActivation : () => dispatch(showModal({modalKey: MODAL_RESENT_ACTIVATION_ANCHOR})),
        onChangeFilter: (countryCode, name) => {
            dispatch(setCountryFilter(countryCode));
            dispatch(fetchGetValidatedOrgs(null, countryCode, name));
        },
        onSetContinent: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onRemoveOrg: () => dispatch(showModal({modalKey: MODAL_REMOVE_ORG})),
        onClearFilter: () => dispatch(setCountryFilter(null))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgsList);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgsList/OrgsList.container.js